// import logo from './logo.svg';
import React, { Component } from 'react';

import './App.css';
import Main from './Main';
import { CookiesProvider } from 'react-cookie';
import { CookieBanner } from '@palmabit/react-cookie-law';
import { colorPens } from './utils/colors';

function App() {
  return (
    <div className="App">
      <CookiesProvider>
        <Main />
        <CookieBanner
          styles={{
            dialog: {
              backgroundColor: 'rgba(60, 60, 60, 0.85)',
              position: 'fixed',
              bottom: '0',
              // height: '45px',
              width: '100%',
              padding: '10px',
              zIndex: '10000'
            },
            message: {
              // fontWeight: 500,
              color: colorPens.light
            },
            policy: {
              color: colorPens.warning
            },
            optionLabel: {
              color: colorPens.light,
              padding: '1px 0 0 20px'
            }
          }}
          message="This site or third-party tools used by this make use of cookies necessary for the operation and useful for the purposes outlined in the cookie policy. To learn more, see the privacy policy. By accepting, you consent to the use of cookies."
          policyLink="/policy/privacy"
          wholeDomain={true}
          preferencesDefaultChecked={false}
          statisticsDefaultChecked={false}
          marketingDefaultChecked={false}
        />
      </CookiesProvider>
    </div>
  );
}

export default App;
